module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_32.c808222b.png";